import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { LoginComponent } from "./Main/Components/login/login.component";
import { ComponentSecurityRevisionsComponent } from "./Main/Components/component-security-revisions/component-security-revisions.component";
import { UdcRevisionsComponent } from "./Main/Components/udc-revisions/udc-revisions.component";
import { CompanyMasterRevisionsComponent } from "./Main/Components/company-master-revisions/company-master-revisions.component";
import { UserMasterRevisionsComponent } from "./Main/Components/user-master-revisions/user-master-revisions.component";
import { MenuSecurityRevisionsComponent } from "./Main/Components/menu-security-revisions/menu-security-revisions.component";
import { PrintFolderRevisionsComponent } from "./Main/Components/print-folder-revisions/print-folder-revisions.component";
import { B2bLoginComponent } from "./Main/Components/b2b-login/b2b-login.component";
import { HomeComponent } from "./Main/Components/home/home.component";
import { EmployeeMasterRevisionsComponent } from "./Main/Components/employee-master-revisions/employee-master-revisions.component";

const routes: Routes = [
  {
    path: "sales",
    loadChildren: () =>
      import("../app/Sales/sales.module").then((m) => m.SalesModule),
  },
  {
    path: "shopfloor",
    loadChildren: () =>
      import("../app/ShopFloor/shopfloor.module").then(
        (m) => m.ShopFloorModule
      ),
  },
  {
    path: "ar",
    loadChildren: () =>
      import("../app/AccountsReceivable/accounts-receivable.module").then(
        (m) => m.AccountsReceivableModule
      ),
  },
  {
    path: "ap",
    loadChildren: () =>
      import("../app/AccountsPayable/accounts-payable.module").then(
        (m) => m.AccountsPayableModule
      ),
  },
  {
    path: "inventory",
    loadChildren: () =>
      import("../app/Inventory/inventory.module").then(
        (m) => m.InventoryModule
      ),
  },
  {
    path: "generalLedger",
    loadChildren: () =>
      import("../app/GeneralLedger/general-ledger.module").then(
        (m) => m.GeneralLedgerModule
      ),
  },
  {
    path: "",
    component: B2bLoginComponent,
  },
  {
    path: "b2blogin",
    component: B2bLoginComponent,
  },
  {
    path: "componentSecurityRevisions",
    component: ComponentSecurityRevisionsComponent,
  },
  {
    path: "udcRevisions",
    component: UdcRevisionsComponent,
  },
  {
    path: "companyMasterRevisions",
    component: CompanyMasterRevisionsComponent,
  },
  {
    path: "userMasterRevisions",
    component: UserMasterRevisionsComponent,
  },
  {
    path: "menuSecurityRevisions",
    component: MenuSecurityRevisionsComponent,
  },
  {
    path: "printFolderRevisions",
    component: PrintFolderRevisionsComponent,
  },
  {
    path: "home",
    component: HomeComponent,
  },
  {
    path: "employeeRevisions",
    component: EmployeeMasterRevisionsComponent,
    data: {
      title: "shopfloor",
    },
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
